import {
  IOrderItemType,
  IPluralizedOrderItemType,
} from "@modules/Purchasing/services/orders";
import { OrderDescriptionColorScheme } from "./types";

export const ORDER_OF_ITEMS: IOrderItemType[] = [
  "service",
  "expense",
  "product",
];

export const GROUP_ITEM_TYPES: {
  [key in IOrderItemType]: IPluralizedOrderItemType;
} = {
  expense: "expenses",
  product: "products",
  service: "services",
};

const COLOR_SCHEME_BORDER_COLORS = {
  sand: "sand.500",
  white: "gray.300",
};

const DARK_COLOR_SCHEME_BORDER_COLORS = {
  sand: "sand.700",
  white: "gray.500",
};

export const getBorderColor = (
  colorScheme: OrderDescriptionColorScheme = "white"
) => {
  return COLOR_SCHEME_BORDER_COLORS[colorScheme];
};

export const getDarkBorderColor = (
  colorScheme: OrderDescriptionColorScheme = "white"
) => {
  return DARK_COLOR_SCHEME_BORDER_COLORS[colorScheme];
};
